export default "__VITE_ASSET__BAfKVohd__"